import React from 'react';
import { Container, Card } from 'react-bootstrap';

const CompetitionRules = () => {
    return (
        <Container className="mt-3">
            <Card className="mt-3">
                <Card.Header as="h5">Competition Rules</Card.Header>
                <Card.Body>
                    <Card.Text>
                        Welcome to our competition! This competition is a fun way to encourage
                        physical activity among team members.
                    </Card.Text>
                    <Card.Text>
                        <strong>Duration and Timing:</strong> The competition runs between two predetermined dates.
                        All activities must be logged within this timeframe to count towards your total points.
                        The competition always concludes with a team meeting at 9 AM on a Friday, where the winner
                        is announced.
                    </Card.Text>
                    <Card.Text>
                        <strong>Activity Tracking:</strong> To ensure the accuracy and integrity of all logged activities,
                        participants must use an official fitness tracking app to record their efforts. Acceptable platforms
                        include Strava, Google Fit, Samsung Health, Runkeeper, WorkOutDoors, or Garmin Connect. Only activities recorded and verified
                        through these approved apps will be considered valid for point calculation and competition standings.
                    </Card.Text>
                    <Card.Text>
                        <strong>Title and Privileges:</strong> The winner of the competition earns the title
                        "Minister of Activity" for the next competition cycle.
                    </Card.Text>
                    <Card.Text>
                        <strong>Cake Threshold and Responsibilities:</strong> 80 percent of the total points
                        accumulated by the winner are set as the "cake threshold" for the next competition. The
                        competitor who scores the least in the competition must provide cake to all participants
                        who score above this threshold in the subsequent competition. Notably, the Minister of
                        Activity is exempt from this cake-giving responsibility!
                    </Card.Text>
                    <Card.Text>
                        Below are the details on how points are calculated for each type of activity:
                    </Card.Text>
                    <Card.Text>
                        <strong>Running:</strong> Points are awarded based on the distance (1 point per km) plus
                        an additional point for every 100 meters of elevation gained. A minimum of 2 km with a pace of at least 9 min/km are required.
                    </Card.Text>
                    <Card.Text>
                        <strong>Cycling:</strong> Points for cycling are calculated as a quarter of the distance
                        (0.25 points per km), with an additional point for every 200 meters of elevation gained. A minimum of 10 km with a speed of at least 18 km/h are required.
                    </Card.Text>
                    <Card.Text>
                        <strong>Swimming:</strong> Swimming awards four times the points per kilometer swum
                        (4 points per km), reflecting its high physical demand compared to other activities. A minimum of 100 meters are required.
                    </Card.Text>
                    <Card.Text>
                        <strong>Hiking:</strong> Points for hiking are calculated based on the distance, with an initial
                        0.5 points per km. Additionally, for every 100 meters of elevation gained, the points increase by 0.5.
                        Thus, hiking 1 km with 100 meters of elevation would yield 1 point total (0.5 for the distance and
                        0.5 for the elevation). A minimum of 3 km with a pace of at least 20 min/km are required.
                    </Card.Text>

                    <Card.Text>
                        <strong>Football:</strong> Football scoring is straightforward, with 1 point awarded per km
                        covered during play. Elevation does not impact the score in football.
                    </Card.Text>
                    <Card.Text>
                        Please ensure that all activities are logged accurately and within the competition timeline
                        to ensure they count towards your total points. Let the competition begin, and may the best
                        competitor win!
                    </Card.Text>

                    <Card.Text>
                        <strong>The right to disqualify activities:</strong> The FitOps challenge is a gentleman's challenge where trust is key. The main purpose is to get people out and be active.
                        Thus, the FitOps Dictator claims the right to disqualify any activity if it is deemed to take advantage of any loophole in the rules. The dictator is not evil, so if any of the requirements in the rules are too strict, they may be loosened upon request.
                    </Card.Text>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default CompetitionRules;
